import React from 'react';
import { cn, getTrendIcon, getTrendColor } from '@/utils';

interface MetricsCardProps {
  title: string;
  value: string | number;
  change?: {
    value: number;
    label: string;
  };
  status?: 'healthy' | 'warning' | 'critical';
  icon?: string;
  description?: string;
}

export const MetricsCard: React.FC<MetricsCardProps> = ({ 
  title, 
  value, 
  change, 
  status,
  icon,
  description 
}) => {
  const getStatusColor = () => {
    switch (status) {
      case 'healthy':
        return 'border-emerald-500/30 bg-emerald-500/5';
      case 'warning':
        return 'border-amber-500/30 bg-amber-500/5';
      case 'critical':
        return 'border-red-500/30 bg-red-500/5';
      default:
        return 'border-slate-600';
    }
  };

  return (
    <div className={cn(
      'bg-slate-700 rounded-lg border p-6 transition-all duration-200 hover:bg-slate-600/50',
      getStatusColor()
    )}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-sm font-medium text-slate-300 mb-2">
            {title}
          </h3>
          <div className="flex items-center space-x-2">
            <span className="text-2xl font-bold text-slate-50">
              {value}
            </span>
            {icon && (
              <span className="text-lg" role="img" aria-hidden="true">
                {icon}
              </span>
            )}
          </div>
          {change && (
            <div className="mt-2 flex items-center space-x-1">
              <span className={cn('text-sm', getTrendColor(change.value))}>
                {getTrendIcon(change.value)} {Math.abs(change.value)}
              </span>
              <span className="text-sm text-slate-400">
                {change.label}
              </span>
            </div>
          )}
          {description && (
            <p className="text-sm text-slate-400 mt-1">
              {description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};